import { ContentItem, ContentForTabs } from '../Guides.types';

export const createContentForTabs = (content: ContentItem[]): ContentForTabs => {
  const contentObject: ContentForTabs = {
    all: content,
    guides: [],
    terms: [],
    checklist: [],
  };

  content.forEach((item) => contentObject[item.category].push(item));

  return contentObject;
};
